import { LitElement, html } from 'lit';
import componentStyles from './fil-modal-footer.styles.js';

export class FilModalFooter extends LitElement {
  static properties = {
    alignment: { type: String },
  };

  static styles = [componentStyles];

  slotChangeHandler() {
    const slot = this.shadowRoot.querySelector('slot');
    const buttonsElement =
      slot
        ?.assignedElements()
        .filter(node => /^fil-button-group$/.test(node.tagName.toLowerCase())) || [];
    if (buttonsElement.length > 0) {
      this._buttonGroup = buttonsElement[0];
      if (this.alignment && this._buttonGroup) {
        this._buttonGroup.setAttribute('position', this.alignment);
      }
    }
  }

  render() {
    return html`<slot @slotchange=${this.slotChangeHandler}></slot>`;
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has('alignment') && this._buttonGroup) {
      if (this.alignment) {
        this._buttonGroup.setAttribute('position', this.alignment);
      } else {
        this._buttonGroup.removeAttribute('position');
      }
    }
  }
}

export default FilModalFooter;
